import { render, staticRenderFns } from "./ManageAdminRoles.vue?vue&type=template&id=c8c5d26a&scoped=true&"
import script from "./ManageAdminRoles.vue?vue&type=script&lang=js&"
export * from "./ManageAdminRoles.vue?vue&type=script&lang=js&"
import style0 from "./ManageAdminRoles.vue?vue&type=style&index=0&id=c8c5d26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c5d26a",
  null
  
)

export default component.exports